import MediaActionProvider from 'components/SendItems/AddMediaContent/Context/MediaActioncontext';
import { MEDIA_OFFER_NO_PERMISSION } from 'hooks/useMediaOfferPermission';

import ArticleOrderMedia from '.';

/**
 * @description `ArticleOrderMedia`'yı kendi `MediaActionProvider`'ı ile saran giriş noktası — ekranlar
 * tabloyu her zaman buradan kullanır (tetik ve modal aynı provider ağacında kalsın diye).
 *
 * Yetki tek bir nesne olarak geçilir: `permission={useMediaOfferPermission(offer)}`. Ekranlar bu
 * nesnenin içinden seçim yapmaz, parçalamaz, kendi koşullarıyla değiştirmez — yetkinin tek karar
 * noktası hook'tur. Geçilmezse tablo salt-görüntüleme çalışır.
 *
 * Diğer prop'ların anlamları ve default'ları `ArticleOrderMedia`'da JSDoc ile tanımlıdır; burada
 * yalnız aynı default'lar tekrarlanır ki dallara `undefined` sızmasın.
 *
 * @param {Object} props
 * @param {number|string} props.offerID İlgili makale teklifinin ID'si.
 * @param {import('hooks/useMediaOfferPermission').MediaOfferPermission} [props.permission=MEDIA_OFFER_NO_PERMISSION]
 *   `useMediaOfferPermission(offer)` dönüşü, olduğu gibi.
 * @param {boolean} [props.isContentSend=false] Madde dosyaları bloğu + "Medya Teklifi" başlığı gösterilsin mi.
 * @param {boolean} [props.isEncylopediaUnitControl=false] Ansiklopedi birimi kontrol bağlamı.
 * @param {boolean} [props.isCommiteeControlColumnsVisible=false] "Karar" kolonu görünürlüğü.
 * @param {boolean} [props.isSubmitFlow=false] Gönderim formu bağlamı (kararsız modal, "Ekle" gizli).
 * @param {boolean} [props.hideContentFiles=false] Madde dosyası/kimlik/ÜVKA indirme bloğunu gizler.
 */
function ArticleOrderMediaWrapper({
  offerID,
  permission = MEDIA_OFFER_NO_PERMISSION,
  isContentSend = false,
  isEncylopediaUnitControl = false,
  isCommiteeControlColumnsVisible = false,
  isSubmitFlow = false,
  hideContentFiles = false,
}) {
  return (
    <MediaActionProvider>
      <ArticleOrderMedia
        offerID={offerID}
        permission={permission}
        isContentSend={isContentSend}
        isEncylopediaUnitControl={isEncylopediaUnitControl}
        isCommiteeControlColumnsVisible={isCommiteeControlColumnsVisible}
        isSubmitFlow={isSubmitFlow}
        hideContentFiles={hideContentFiles}
      />
    </MediaActionProvider>
  );
}
export default ArticleOrderMediaWrapper;
